(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grails-shop-reveal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grails-shop-reveal')) {
    customElements.define(
      'grails-shop-reveal',
      class GrailsShopReveal extends HTMLElement {
        connectedCallback() {
          this.cats = Array.from(this.querySelectorAll('.grails-shop-reveal__cat'));
          this.groups = Array.from(this.querySelectorAll('.grails-shop-reveal__group'));

          this.cats.forEach((cat) => {
            cat.addEventListener('pointerenter', this.onActivate);
            cat.addEventListener('focus', this.onActivate);
          });
          this.addEventListener('pointerleave', this.onReset);
        }

        disconnectedCallback() {
          this.cats?.forEach((cat) => {
            cat.removeEventListener('pointerenter', this.onActivate);
            cat.removeEventListener('focus', this.onActivate);
          });
          this.removeEventListener('pointerleave', this.onReset);
        }

        onActivate = (event) => {
          const index = event.currentTarget?.dataset?.revealIndex;
          if (index != null) this.setActive(index);
        };

        // On close (pointer leaves the whole panel) fall back to the first category,
        // so the next open shows the default group.
        onReset = () => {
          this.setActive('0');
        };

        setActive(index) {
          this.cats.forEach((cat) => {
            const on = cat.dataset.revealIndex === index;
            cat.classList.toggle('is-active', on);
            if (on) cat.setAttribute('aria-current', 'true');
            else cat.removeAttribute('aria-current');
          });
          this.groups.forEach((group) => {
            const on = group.dataset.revealGroup === index;
            group.classList.toggle('is-active', on);
            group.setAttribute('aria-hidden', on ? 'false' : 'true');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
